<template>
  <section class="recommend_panel" id="hour24" v-show="rec_list.length != 0">
    <div class="title">河南24小时</div>
    <div>
      <div
        v-for="item in rec_list.list"
        :key="item.id"
        class="list_item has_recommend"
      >
        <a class="list_item_thumb" :href="item.url">
          <img :src="coverIMG(item.coverImagesList)" :alt="item.title" />
        </a>
        <a class="list_item_infor" :href="item.url">
          <div class="list_item_title">
            {{ item.title }}
          </div>
          <div class="list_item_extra">
            <span>{{ item.from }}</span>
            <span>{{ handleDate(item.publishDate) }}</span>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { getHour24 } from "../sdk/sdk";
import { coverIMG } from "../util/helper";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/zh-cn";

dayjs.locale("zh-cn");

dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);

export default {
  data() {
    return {
      rec_list: [],
    };
  },
  async beforeMount() {
    const data = await getHour24();
    if (data.state == 1) {
      this.rec_list = data.data;
      console.log(this.rec_list);
    }
  },
  methods: {
    coverIMG(e) {
      return coverIMG(e);
    },
    handleDate(d) {
      const after = dayjs(+d);
      const now = dayjs();
      const diff = now.diff(after, "day");
      if (diff > 0) {
        return after.format("YYYY-MM-DD");
      } else {
        return after.fromNow();
      }
    },
  },
};
</script>

